import { render, staticRenderFns } from "./komisyonateslim.vue?vue&type=template&id=4b7299ae&"
import script from "./komisyonateslim.vue?vue&type=script&lang=js&"
export * from "./komisyonateslim.vue?vue&type=script&lang=js&"
import style0 from "./komisyonateslim.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports